import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import MembershipManagement from "../components/membership/MembershipManagement";

const styles = (theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  },
  pageTitle: {
    fontSize: "1.8rem",
    fontWeight: 525,
    color: theme.palette.text.primary,
    marginBottom: "2rem",
    letterSpacing: "-0.02em",
    lineHeight: 1.2,
  },
});

function MembershipPage({ classes, catalog }) {
  const adminUserId = catalog?.user?.userId;

  return (
    <div className={classes.root}>
      <Typography className={classes.pageTitle}>Membership Management</Typography>
      <Paper style={{ borderRadius: 12 }}>
        <MembershipManagement adminUserId={adminUserId} />
      </Paper>
    </div>
  );
}

const mapStateToProps = (state) => ({
  catalog: state.catalogReducer,
});

export default connect(mapStateToProps)(withStyles(styles)(MembershipPage));
